/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>案例管理</el-breadcrumb-item>
      <el-breadcrumb-item>回访详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        <div class="titlelist"><div class="icons"></div>相关信息</div>
		<div class="listout">
			<div class="list">
				<div class="listleft">创建方式：{{list.createType}}</div>
			</div>
			<div class="list">
				<div class="listleft">回访类型：{{list.caseType}}</div>
			</div>
			<div class="list">
				<div class="listleft">创建人：{{list.creatorName}}</div>
			</div>
			<div class="list">
				<div class="listleft">创建时间：{{list.createTime}}</div>
			</div>
			
			
		</div>
		
		
		<div class="listout">
			<div class="list">
				<div class="listleft">审核状态：{{list.caseName}}</div>
			</div>
			<div class="list">
				<div class="listleft">审核人：{{list.auditorName}}</div>
			</div>
			<div class="list">
				<div class="listleft">审核意见：{{list.auditMessage}}</div>
			</div>
			<div class="list">
				<div class="listleft">审核时间：{{list.auditTime}}</div>
			</div>
			
		</div>
		
		
		<div class="titlelist"><div class="icons"></div>内容信息</div>
		<div class="listout">
			<div class="list">
				<div class="listleft">回访名称：{{list.caseName}}</div>
			</div>
			
		</div>
		<div class="listout">
			<div class="list">
				  <!-- <div class="imglist" v-for="(item,index) in resultFilelist">
					  <img :src="item.url"/>
				  </div> -->
				  <video class="imglist" controls v-for="(item,index) in resultFilelist">
					<source :src="item.url" type="video/mp4">
					您的浏览器不支持 HTML5 video 标签。
				  </video>
				  
				  
			</div>
			
			
		</div>
		
		
		
		
      </div>
    </template>

    <script>
	// 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getcustomerCase,
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          list:[],
		  resultFilelist:[],
		  lists:[],
		  fileList: [],
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.handleEdit()
		  
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getcustomerCase(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         this.list = res.data
				  this.resultFilelist = []
				 // this.resultFilelist = res.data.pictureInfoList
				 console.log(888889,this.resultFilelist)
				 res.data.queryVideoDtoList.map((item,index)=>{
				     this.resultFilelist.push({
				       url:item.fileTemporaryUrl,
				       fileTemporaryUrl:item.fileTemporaryUrl,
				       fileId:item.fileId
				     })
				     
				 })
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		 
		//编辑
		goback() {
			this.$router.push({ path: '/installation'})
		 
		},
		

      }
    }
    </script>

    <style scoped>
	.listout{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 14px;
	}
	.list{
		width: 25%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	.lists{
		width: 40%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	
	.titlelist{
		margin: 0 auto;
		height: 30px;
		text-align: left;
		line-height: 30px;
		margin-top: 40px;
		padding-left: 10px;
		width: 96%;
		position: relative;
	}
	.icons{
		height: 22px;
		width: 4px;
		border-radius: 10px;
		background-color: #000;
		position: absolute;
		left: 0;
		top: 4px;
	}
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
	.user-searchs {
	  margin-top: 20px;
	}
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		height: 85%;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tableout{
	  width: 95%;
	  height: 120px;
	  border: 1px solid #d9d9d9;
	  border-radius: 5px;
	  font-size: 14px;
  }
  .tablelist{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  
  }
  .tablelists{
  	  width: 100%;
  	  height: 40px;
  	  line-height: 40px;
  	  text-align: center;
  	  display: flex;
  	  
  }
  .tabletitle{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  display: flex;
	  background-color: #ebe8e8;
  }
  .tabileleft{
	  width: 50%;
	  text-align: center;
	  
  }
  .tabileright{
	  width: 50%;
	  text-align: center;
  }
  .liststable{
  	width: 25%;
  }
  .listouts{
  	width: 96%;
  	display: flex;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .imglist img{
	  width: 100px;
	  height: 100px;
  }
  .imglist{
  	  width: 300px;
  	  height: 150px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/management/returnvisitbian.vue